
// FEATURE FILE TYPES
export const GET_FEATURE_FILE_TYPES = "/feature-file-types";
export const ADD_NEW_FEATURE_FILE_TYPE = "/feature-file-types";
export const UPDATE_FEATURE_FILE_TYPE = "/feature-file-types";
export const DELETE_FEATURE_FILE_TYPE = "/feature-file-types";


